/* ================================
   BURGER PRIME - GALLERY FEATURES
   ================================ */

// Gallery state
let currentFilter = 'all';
let uploadedPhotos = [];
let isUploading = false;

// Gallery filtering functionality
function filterGallery(category, e) {
    const items = document.querySelectorAll('.gallery-item');
    const buttons = document.querySelectorAll('.gallery-filter .filter-btn');

    // Update button states
    buttons.forEach(btn => btn.classList.remove('active'));
    if (e && e.target) {
        e.target.classList.add('active');
    }
    
    // Update current filter
    currentFilter = category;
    
    // Filter items with stagger animation
    items.forEach((item, index) => {
        setTimeout(() => {
            if (category === 'all' || item.dataset.category === category) {
                item.style.display = 'block';
                item.classList.add('fade-in');
                item.style.animationDelay = `${index * 0.1}s`;
            } else {
                item.style.opacity = '0';
                item.style.transform = 'scale(0.8)';
                setTimeout(() => {
                    item.style.display = 'none';
                }, 300);
            }
        }, index * 50);
    });
    
    // Update gallery count
    updateGalleryCount();
}

// Update gallery item count
function updateGalleryCount() {
    const visibleItems = document.querySelectorAll('.gallery-item[style*="block"], .gallery-item:not([style*="none"])');
    const countElement = document.querySelector('.gallery-count');
    if (countElement) {
        countElement.textContent = `${visibleItems.length} photos`;
    }
}

// Photo upload handling
function handlePhotoUpload(event) {
    const files = event.target.files;
    if (!files.length) return;
    
    const previewSection = document.getElementById('photoPreview');
    const previewGrid = document.getElementById('previewGrid');
    
    if (files.length > 0) {
        previewSection.style.display = 'block';
        previewGrid.innerHTML = '';
        
        // Show upload progress
        showUploadProgress();
        
        Array.from(files).forEach((file, index) => {
            if (file.type.startsWith('image/')) {
                processImageFile(file, index);
            }
        });
        
        // Hide progress after processing
        setTimeout(() => {
            hideUploadProgress();
        }, 1000 + (files.length * 200));
    }
}

// Process individual image file
function processImageFile(file, index) {
    const reader = new FileReader();
    
    reader.onload = function(e) {
        const photoItem = document.createElement('div');
        photoItem.className = 'preview-item';
        photoItem.style.cssText = `
            position: relative;
            height: 200px;
            border-radius: 10px;
            overflow: hidden;
            background-image: url(${e.target.result});
            background-size: cover;
            background-position: center;
            border: 3px solid var(--accent-gold);
            cursor: pointer;
            transition: all 0.3s ease;
            animation: slideInUp 0.4s ease-out ${index * 0.1}s both;
        `;
        
        // Add hover effect
        photoItem.addEventListener('mouseenter', function() {
            this.style.transform = 'scale(1.05)';
            this.style.boxShadow = '0 10px 25px rgba(255, 215, 0, 0.4)';
        });
        
        photoItem.addEventListener('mouseleave', function() {
            this.style.transform = 'scale(1)';
            this.style.boxShadow = 'none';
        });
        
        // Add click to view full size
        photoItem.addEventListener('click', function() {
            openImageModal(e.target.result, file.name);
        });
        
        const overlay = document.createElement('div');
        overlay.className = 'preview-overlay';
        overlay.style.cssText = `
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            background: linear-gradient(transparent, rgba(0,0,0,0.8));
            color: white;
            padding: 1rem;
            font-size: 0.9rem;
            transform: translateY(100%);
            transition: transform 0.3s ease;
        `;
        
        const overlayContent = document.createElement('div');
        overlayContent.style.cssText = 'display: flex; justify-content: space-between; align-items: center;';
        const nameSpan = document.createElement('span');
        nameSpan.textContent = file.name;
        const sizeSpan = document.createElement('span');
        sizeSpan.style.cssText = 'font-size: 0.8rem; opacity: 0.8;';
        sizeSpan.textContent = formatFileSize(file.size);
        overlayContent.append(nameSpan, sizeSpan);
        overlay.appendChild(overlayContent);
        
        photoItem.appendChild(overlay);
        
        // Show overlay on hover
        photoItem.addEventListener('mouseenter', function() {
            overlay.style.transform = 'translateY(0)';
        });
        
        photoItem.addEventListener('mouseleave', function() {
            overlay.style.transform = 'translateY(100%)';
        });
        
        document.getElementById('previewGrid').appendChild(photoItem);
        
        // Save to uploaded photos array
        uploadedPhotos.push({
            file: file,
            dataUrl: e.target.result,
            name: file.name,
            size: file.size,
            uploadedAt: new Date().toISOString()
        });
        
        // Auto-categorize based on filename or add to general category
        const category = detectImageCategory(file.name);
        if (category !== 'general') {
            addToGalleryCategory(e.target.result, file.name, category);
        }
    };
    
    reader.readAsDataURL(file);
}

// Detect image category from filename
function detectImageCategory(filename) {
    const name = filename.toLowerCase();
    
    if (name.includes('burger') || name.includes('sandwich')) return 'burgers';
    if (name.includes('pizza')) return 'pizzas';
    if (name.includes('fries') || name.includes('appetizer') || name.includes('wings') || name.includes('chicken')) return 'appetizers';
    if (name.includes('dessert') || name.includes('cake') || name.includes('brownie') || name.includes('sweet')) return 'desserts';
    if (name.includes('restaurant') || name.includes('dining') || name.includes('interior')) return 'ambiance';
    
    return 'general';
}

// Add uploaded image to gallery category
function addToGalleryCategory(imageUrl, fileName, category) {
    const galleryGrid = document.querySelector('.gallery-grid');
    if (!galleryGrid) return;
    
    const galleryItem = document.createElement('div');
    galleryItem.className = 'gallery-item';
    galleryItem.dataset.category = category;
    galleryItem.style.cssText = `
        position: relative;
        height: 250px;
        border-radius: 15px;
        overflow: hidden;
        cursor: pointer;
        transition: all 0.3s ease;
        background-image: url(${imageUrl});
        background-size: cover;
        background-position: center;
        animation: bounceIn 0.6s ease-out;
    `;
    
    galleryItem.innerHTML = `
        <div class="gallery-content">
            <h3>📸 Customer Photo</h3>
            <p>Shared by our valued customer</p>
            <div style="margin-top: 1rem;">
                <span style="background: rgba(255,255,255,0.2); padding: 0.3rem 0.8rem; border-radius: 15px; margin-right: 0.5rem;">#CustomerShare</span>
                <span style="background: rgba(255,255,255,0.2); padding: 0.3rem 0.8rem; border-radius: 15px;">#Fresh</span>
            </div>
        </div>
    `;
    
    // Add click handler
    galleryItem.addEventListener('click', function() {
        openImageModal(imageUrl, fileName);
    });
    
    // Add to beginning of gallery
    galleryGrid.insertBefore(galleryItem, galleryGrid.firstChild);
    
    // Update count
    updateGalleryCount();
    
    // Show success message
    showUploadSuccess(fileName);
}

// Format file size for display
function formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

// Show upload progress
function showUploadProgress() {
    const progressDiv = document.querySelector('.upload-progress');
    if (progressDiv) {
        progressDiv.style.display = 'block';
        const progressBar = progressDiv.querySelector('.upload-progress-bar');
        
        let progress = 0;
        const interval = setInterval(() => {
            progress += Math.random() * 15;
            if (progress >= 100) {
                progress = 100;
                clearInterval(interval);
            }
            progressBar.style.width = progress + '%';
        }, 100);
    }
}

// Hide upload progress
function hideUploadProgress() {
    const progressDiv = document.querySelector('.upload-progress');
    if (progressDiv) {
        setTimeout(() => {
            progressDiv.style.display = 'none';
            const progressBar = progressDiv.querySelector('.upload-progress-bar');
            progressBar.style.width = '0%';
        }, 500);
    }
}

// Show upload success message
function showUploadSuccess(fileName) {
    const successDiv = document.createElement('div');
    successDiv.className = 'upload-success';
    successDiv.style.cssText = `
        position: fixed;
        top: 100px;
        right: 30px;
        background: #4CAF50;
        color: white;
        padding: 1rem 1.5rem;
        border-radius: 10px;
        box-shadow: 0 5px 20px rgba(76, 175, 80, 0.4);
        z-index: 10000;
        animation: slideInRight 0.3s ease-out;
    `;
    
    const successContent = document.createElement('div');
    successContent.style.cssText = 'display: flex; align-items: center; gap: 0.5rem;';
    const checkIcon = document.createElement('span');
    checkIcon.textContent = '\u2705';
    const successText = document.createElement('span');
    const boldName = document.createElement('strong');
    boldName.textContent = fileName;
    successText.appendChild(boldName);
    successText.append(' uploaded successfully!');
    successContent.append(checkIcon, successText);
    successDiv.appendChild(successContent);
    
    document.body.appendChild(successDiv);
    
    setTimeout(() => {
        successDiv.style.animation = 'slideOutRight 0.3s ease-in';
        setTimeout(() => successDiv.remove(), 300);
    }, 3000);
}

// Open image modal for full view
function openImageModal(imageUrl, fileName) {
    const modal = document.createElement('div');
    modal.className = 'gallery-modal active';
    modal.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.9);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10000;
        animation: fadeIn 0.3s ease-out;
    `;
    
    const modalContent = document.createElement('div');
    modalContent.className = 'modal-content';
    modalContent.style.cssText = 'max-width: 90%; max-height: 90%; position: relative;';

    const img = document.createElement('img');
    img.src = imageUrl;
    img.alt = fileName;
    img.style.cssText = 'width: 100%; height: auto; border-radius: 10px; box-shadow: 0 20px 60px rgba(0,0,0,0.5);';

    const closeBtn = document.createElement('button');
    closeBtn.className = 'modal-close';
    closeBtn.style.cssText = 'position: absolute; top: -40px; right: 0; background: none; border: none; color: white; font-size: 2rem; cursor: pointer; transition: all 0.3s ease;';
    closeBtn.textContent = '\u2715';

    const caption = document.createElement('div');
    caption.style.cssText = 'position: absolute; bottom: -40px; left: 0; color: white; font-size: 1rem;';
    caption.textContent = fileName;

    modalContent.append(img, closeBtn, caption);
    modal.appendChild(modalContent);
    
    // Close modal handlers
    const modalCloseBtn = modal.querySelector('.modal-close');
    modalCloseBtn.addEventListener('click', closeImageModal);
    modal.addEventListener('click', function(e) {
        if (e.target === modal) closeImageModal();
    });
    
    // Keyboard handler
    const handleKeyPress = function(e) {
        if (e.key === 'Escape') {
            closeImageModal();
        }
    };
    
    document.addEventListener('keydown', handleKeyPress);
    modal.setAttribute('data-keyhandler', 'true');
    
    document.body.appendChild(modal);
    
    function closeImageModal() {
        modal.style.animation = 'fadeOut 0.3s ease-in';
        setTimeout(() => {
            modal.remove();
            document.removeEventListener('keydown', handleKeyPress);
        }, 300);
    }
}

// Drag and drop functionality
function initializeDragAndDrop() {
    const uploadArea = document.querySelector('.upload-area');
    if (!uploadArea) return;
    
    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
        uploadArea.addEventListener(eventName, preventDefaults, false);
        document.body.addEventListener(eventName, preventDefaults, false);
    });
    
    ['dragenter', 'dragover'].forEach(eventName => {
        uploadArea.addEventListener(eventName, highlight, false);
    });
    
    ['dragleave', 'drop'].forEach(eventName => {
        uploadArea.addEventListener(eventName, unhighlight, false);
    });
    
    uploadArea.addEventListener('drop', handleDrop, false);
    
    function preventDefaults(e) {
        e.preventDefault();
        e.stopPropagation();
    }
    
    function highlight() {
        uploadArea.classList.add('dragover');
    }
    
    function unhighlight() {
        uploadArea.classList.remove('dragover');
    }
    
    function handleDrop(e) {
        const dt = e.dataTransfer;
        const files = dt.files;
        
        // Create a fake event object for handlePhotoUpload
        const fakeEvent = { target: { files: files } };
        handlePhotoUpload(fakeEvent);
    }
}

// Initialize gallery functionality
function initializeGallery() {
    // Set up photo upload handler
    const photoUpload = document.getElementById('photoUpload');
    if (photoUpload) {
        photoUpload.addEventListener('change', handlePhotoUpload);
    }
    
    // Initialize drag and drop
    initializeDragAndDrop();
    
    // Initialize gallery filters
    initializeGalleryFilters();
    
    // Initialize existing gallery items
    initializeGalleryItems();
    
    // Load saved photos from localStorage
    loadSavedPhotos();
    
    console.log('📸 Gallery initialized');
}

// Initialize gallery filter buttons
function initializeGalleryFilters() {
    const filterButtons = document.querySelectorAll('.gallery-filter .filter-btn');
    filterButtons.forEach(button => {
        button.addEventListener('click', function() {
            const category = this.getAttribute('onclick')?.match(/filterGallery\('(.+?)'\)/)?.[1] || 'all';
            filterGallery(category);
        });
    });
}

// Initialize existing gallery items
function initializeGalleryItems() {
    const galleryItems = document.querySelectorAll('.gallery-item');
    galleryItems.forEach((item, index) => {
        // Add click handler for modal view
        item.addEventListener('click', function() {
            const bgImage = window.getComputedStyle(this).backgroundImage;
            const imageUrl = bgImage.slice(5, -2); // Remove 'url("' and '")'
            const title = this.querySelector('h3')?.textContent || 'Gallery Image';
            
            if (imageUrl && imageUrl !== 'none') {
                openImageModal(imageUrl, title);
            }
        });
        
        // Add stagger animation
        item.style.animationDelay = `${index * 0.1}s`;
        item.classList.add('fade-in');
    });
}

// Save photos to localStorage
function savePhotosToStorage() {
    try {
        localStorage.setItem('burgerPrimeGalleryPhotos', JSON.stringify(uploadedPhotos));
    } catch (error) {
        console.warn('Could not save photos to localStorage:', error);
    }
}

// Load saved photos from localStorage
function loadSavedPhotos() {
    try {
        const savedPhotos = localStorage.getItem('burgerPrimeGalleryPhotos');
        if (savedPhotos) {
            uploadedPhotos = JSON.parse(savedPhotos);
            
            // Re-add photos to gallery if needed
            uploadedPhotos.forEach(photo => {
                const category = detectImageCategory(photo.name);
                if (category !== 'general') {
                    addToGalleryCategory(photo.dataUrl, photo.name, category);
                }
            });
        }
    } catch (error) {
        console.warn('Could not load photos from localStorage:', error);
    }
}

// Clear all uploaded photos
function clearUploadedPhotos() {
    uploadedPhotos = [];
    savePhotosToStorage();
    
    const previewSection = document.getElementById('photoPreview');
    if (previewSection) {
        previewSection.style.display = 'none';
    }
    
    // Remove customer uploaded items from gallery
    const allGalleryItems = document.querySelectorAll('.gallery-item');
    allGalleryItems.forEach(item => {
        const heading = item.querySelector('.gallery-content h3');
        if (heading && heading.textContent.includes('Customer Photo')) {
            item.remove();
        }
    });
    
    updateGalleryCount();
}

// Share photo on social media
function sharePhoto(photoUrl, photoName) {
    if (navigator.share) {
        navigator.share({
            title: 'Check out my Burger Prime experience!',
            text: `Amazing food at Burger Prime! 🍔 #BurgerPrime #Nellore`,
            url: window.location.href
        }).catch(console.error);
    } else {
        // Fallback: copy to clipboard
        const shareText = `Check out my Burger Prime experience! 🍔 #BurgerPrime #Nellore\n${window.location.href}`;
        navigator.clipboard.writeText(shareText).then(() => {
            showUploadSuccess('Share link copied to clipboard!');
        }).catch(() => {
            console.warn('Could not copy to clipboard');
        });
    }
}

// Export gallery module
window.GalleryModule = {
    filterGallery,
    handlePhotoUpload,
    initializeGallery,
    clearUploadedPhotos,
    sharePhoto,
    getUploadedPhotos: () => uploadedPhotos
};

// Make functions globally available
window.filterGallery = filterGallery;
window.handlePhotoUpload = handlePhotoUpload;

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
    // Only initialize if gallery elements exist
    if (document.querySelector('.gallery-grid')) {
        initializeGallery();
    }
});